import { SystemStyleObject } from '@chakra-ui/react';

const baseStyle: SystemStyleObject = {
  color: `inherit`,
  transition: `color 0.25s ease`,
  _hover: {
    textDecoration: `none`,
  },
};

const defaultProps: SystemStyleObject = {
  variant: `default`,
};

export const Link = {
  baseStyle,
  defaultProps,
};
